module.exports = __webpack_public_path__ + "819b3679edc8ee645a398b0be1a1caaa.png";